import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';

import {CommonButton} from './CommonButton.js';

//  import CommonTheme from '../../../Theme.js';

/** デンジャーボタンで使用するパレット */
// const palette = CommonTheme.palette.secondary;

// デンジャーボタンスタイル
const styles = (theme) => createStyles({
  root: {
    color: '#FFFFFF', // palette.contrastText,
    background: [
      // '-webkit-linear-gradient(top, ' + palette.light + ' 0%, ' + palette.main + ' 100%)',
      // 'linear-gradient(to bottom, ' + palette.light + ' 0%, ' + palette.main + ' 100%)',
      '#E60012',
    ],
    borderColor: '#E60012', // palette.dark,
  },
});

const coolStyles = (theme) => createStyles({
  root: {
    color: '#E60012', // palette.contrastText,
    background: [
      // '-webkit-linear-gradient(top, ' + palette.light + ' 0%, ' + palette.main + ' 100%)',
      // 'linear-gradient(to bottom, ' + palette.light + ' 0%, ' + palette.main + ' 100%)',
      '#fff',
    ],
    borderColor: '#C0C0C0', // palette.dark,
  },
});

/** デンジャーボタン */
export const DangerButton = withStyles(styles)(CommonButton);
/** デンジャーボタン */
export const DangerButton2 = withStyles(coolStyles)(CommonButton);
export default DangerButton;
